import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockTakeLine, StockTakeLineCreate, StockTakeLineFilter } from '../data/stockTakeLine';

export function createStockTakeLineService(client: AxiosInstance) {
  return createCrudService<StockTakeLine, StockTakeLineCreate, StockTakeLineFilter>(
    client,
    '/purchase/StockTakeLine',
    'id',
  );
}

export type StockTakeLineService = CrudService<StockTakeLine, StockTakeLineCreate, StockTakeLineFilter>;
